import React, { Component } from 'react';

import './GovernancaDiretoria.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';

// import OwlCarousel from 'react-owl-carousel2';
// import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
// import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views,
	governanca_content
} from '../../settings';

import {
	Person
} from '../../components/';

class GovernancaDiretoria extends Component {

	constructor() {
		super();

        this.images = images;
        this.governanca_content = governanca_content;

        this.state = {
            width: window.innerWidth,
            cardsDiretores: 0,
            lineDiretoresLeft: 0,
            cardsVices: 0,
            lineVicesLeft: 0,
            lineVicesWidth: 0,
            lineDiretoresWidth: 0
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);

        this.scene;
        this.parallaxInstance;
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    prevPersonDiretores() {
    	console.log('prev');
    	if (this.state.cardsDiretores > 0) {
    		this.setState({
    			lineDiretoresLeft: 100 * (this.state.cardsDiretores - 1),
    			lineDiretoresWidth: ((100 / (this.governanca_content.diretores.length - 1)) * (this.state.cardsDiretores - 1)) + '%',
    			cardsDiretores: this.state.cardsDiretores - 1
    		});
    	}
    }

    nextPersonDiretores() {
        const { width } = this.state;
        const isMobile = width <= 769;

        const fraction = (isMobile) ? 1 : 2;
        
    	if (this.state.cardsDiretores < (this.governanca_content.diretores.length - fraction)) {
	    	this.setState({
    			lineDiretoresLeft: 100 * (this.state.cardsDiretores + 1),
    			lineDiretoresWidth: ((100 / (this.governanca_content.diretores.length - 1)) * (this.state.cardsDiretores + 1)) + '%',
    			cardsDiretores: this.state.cardsDiretores + 1
    		});
	    } else {
	    	this.setState({
    			lineDiretoresLeft: 0,
    			lineDiretoresWidth: (100 / (this.governanca_content.diretores.length - 1)) + '%',
    			cardsDiretores: 0
    		});
	    }
    }


    //
    // Vices
    //

    prevPersonVices() {
    	console.log('prev Vices');
    	if (this.state.cardsVices > 0) {
    		this.setState({
    			lineVicesLeft: 100 * (this.state.cardsVices - 1),
    			lineVicesWidth: ((100 / (this.governanca_content.vice_presidents.length - 1)) * (this.state.cardsVices - 1)) + '%',
    			cardsVices: this.state.cardsVices - 1
    		});
    	}
    }

    nextPersonVices() {
    	console.log('next Vices');
    	if (this.state.cardsVices < (this.governanca_content.vice_presidents.length - 1)) {
	    	this.setState({
    			lineVicesLeft: 100 * (this.state.cardsVices + 1),
    			lineVicesWidth: ((100 / (this.governanca_content.vice_presidents.length - 1)) * (this.state.cardsVices + 1)) + '%',
    			cardsVices: this.state.cardsVices + 1
    		});
	    } else {
	    	this.setState({
    			lineVicesLeft: 0,
    			lineVicesWidth: (100 / (this.governanca_content.vice_presidents.length - 1)) + '%',
    			cardsVices: 0
    		});
	    }
    }

    initParallax() {
        this.scene = document.getElementById('scene');
        this.parallaxInstance = new Parallax(this.scene);
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('4.2 Diretoria');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
        // this.initParallax();
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'diretoria'
		];


		// Icon Columns - Diretoria
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

		const iconsHtml = [];
		for (let i = 0; i < this.governanca_content.responsabilidades.length; i++) {
			iconsHtml.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.governanca_content.responsabilidades[i].image } />
					</div>
					<div className="content">
		    			<p className="text">{ renderHTML(this.governanca_content.responsabilidades[i].text) }</p>
					</div>
				</div>
			);
		}

		var outputIconsHtml;
		if (isMobile) {
			outputIconsHtml = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1">
								    { iconsHtml }
								</Carousel>;
		} else {
			outputIconsHtml = iconsHtml;
		}



		const vices = [];
		for (let i = 0; i < this.governanca_content.vice_presidents.length; i++) {
			vices.push(
				<Person
					key={i}
					label={ this.governanca_content.vice_presidents[i].label }
					name={ this.governanca_content.vice_presidents[i].name }
					subtitle={ this.governanca_content.vice_presidents[i].subtitle }
					image={ this.governanca_content.vice_presidents[i].image } />
			);
		}


		var cardsVicesClass = [ 'component_cards', 'component_cards--'+this.state.cardsVices ]; 
		var lineVicesStyle = {
			// transform: 'translateX('+this.state.lineVicesLeft+'%)',
			// width: (100 / (this.governanca_content.vice_presidents.length - 1)) + '%'
			width: this.state.lineVicesWidth
		};



		const diretores = [];
		for (let i = 0; i < this.governanca_content.diretores.length; i++) {
			diretores.push(
				<Person
					key={i}
					label={ this.governanca_content.diretores[i].label }
					name={ this.governanca_content.diretores[i].name }
					subtitle={ this.governanca_content.diretores[i].subtitle }
					image={ this.governanca_content.diretores[i].image } />
			);
		}


		var cardsDiretoresClass = [ 'component_cards', 'component_cards--'+this.state.cardsDiretores ];
		var lineDiretoresStyle = {
			// transform: 'translateX('+this.state.lineDiretoresLeft+'%)',
			// width: (100 / (this.governanca_content.diretores.length - 1)) + '%'	
			width: this.state.lineDiretoresWidth
		};

		const legalText1 = (this.state.cardsVices == 2) ? <div className="legal_text">
											        		<span>1</span> Foi eleito diretor e se tornou vice-presidente em setembro de 2018.
											        	  </div> : '';

		var legalText2;
		if (isMobile) {
			legalText2 = (this.state.cardsDiretores == 0 || this.state.cardsDiretores == 8) ? <div className="legal_text">
											        				<span>2</span> Entrou para a Diretoria em agosto de 2018.
											        			  </div> : '';
		} else {
			legalText2 = (this.state.cardsDiretores == 0 || this.state.cardsDiretores == 7 || this.state.cardsDiretores == 8) ? <div className="legal_text">
											        				<span>2</span> Entrou para a Diretoria em agosto de 2018.
											        			  </div> : '';
		}

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>4.2 Diretoria - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>4.2</span> Diretoria</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Governança corporativa</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
					        			<p className="first_paragraph">
					        				Composta por 22 pessoas, sendo um presidente, oito vice-presidentes e até 13 diretores, nossa Diretoria reflete a pluralidade do mercado, é voluntária e não exerce função executiva na Associação.
					        				<br />
					        				<span className="gri_label"><text>GRI 102-25</text></span>
					        			</p>
					        			<p>
						        			É eleita a cada dois anos, sendo permitida a reeleição por períodos sucessivos, com exceção do presidente, que pode ser reeleito apenas uma vez.
						        		</p>
					        			<p>
											Reúne-se uma vez por mês, mas há também reuniões extraordinárias convocadas pelo presidente ou pela maioria dos membros.
						        		</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content row">
			        		<div className="container">
				        		<div className="column column--image-full column--image-full-center">
				        			<Fade bottom>
				        				<img src={ this.images.diretoria_img1 } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content titled_view disclaimer_view responsabilidades__view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="section_title">Responsabilidades</h2>

					        			<div className="icon_columns row">
						        			{ outputIconsHtml }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content diretoria_view row">

		        			{ legalText1 }

			        		<div className="first_diretoria container">
		        				<img src={ this.images.governanca_vector } className="background-vector" />

				        		<div className="column column--half column--presidente">
				        			<Fade bottom>
				        				<h2 className="section_title">Presidente</h2>

					        			<div className="space_card">
					        				<Person
					        					label={ this.governanca_content.president.label }
					        					name={ this.governanca_content.president.name }
					        					subtitle={ this.governanca_content.president.subtitle }
					        					image={ this.governanca_content.president.image } />
					        			</div>
				        			</Fade>
				        		</div>
				        		<Swipeable
				        			className="column column--half column--vice-presidente"
				        			onSwipedLeft={ this.nextPersonVices.bind(this) }
				        			onSwipedRight={ this.prevPersonVices.bind(this) }>
				        			<Fade bottom>
				        				<h2 className="section_title">Vice-presidentes</h2>
				        			</Fade>

				        			<div className={ cardsVicesClass.join(' ') }>
				        				{ vices }
				        			</div>
				        		</Swipeable>
			        		</div>


			        		<div className="nav_persons">
			        			<button className="nav__prev_person" onClick={ this.prevPersonVices.bind(this) }></button>

			        			<div className="nav__line">
			        				<span>Conheça nossa Diretoria, passe para o lado.</span>
			        				<div className="line"><div style={ lineVicesStyle }></div></div>
			        			</div>

			        			<button className="nav__next_person" onClick={ this.nextPersonVices.bind(this) }></button>
			        		</div>


		        		</div>

		        		<div className="views__content diretores_view row">

		        			{ legalText2 }

			        		<div className="container">
				        		<Swipeable
				        			className="column"
				        			onSwipedLeft={ this.nextPersonDiretores.bind(this) }
				        			onSwipedRight={ this.prevPersonDiretores.bind(this) }>
				        			<Fade bottom>
				        				<h2 className="section_title">Diretores</h2>
				        			</Fade>

				        			<div className={ cardsDiretoresClass.join(' ') }>
				        				{ diretores }
				        			</div>
				        		</Swipeable>
			        		</div>

			        		<div className="nav_persons">
			        			<button className="nav__prev_person" onClick={ this.prevPersonDiretores.bind(this) }></button>

			        			<div className="nav__line">
			        				<span>Conheça nossa Diretoria, passe para o lado.</span>
			        				<div className="line"><div style={ lineDiretoresStyle }></div></div>
			        			</div>

			        			<button className="nav__next_person" onClick={ this.nextPersonDiretores.bind(this) }></button>
			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { GovernancaDiretoria };
